<!--the title follows the link kind the content resolves (organizer link / response link / hint)-->
<ess-dialog-title>
    {{trans.translate(access.titleKey)}}
</ess-dialog-title>
<mat-dialog-content class="dialog-content">
    <get-poll-access #access [dialogRef]="dialogRef"></get-poll-access>
</mat-dialog-content>